var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rights"}},[_c('img',{staticClass:"RImg",attrs:{"src":require("../../assets/入驻福利1.jpg")}}),_c('img',{staticClass:"RImg",attrs:{"src":require("../../assets/入驻福利2.jpg")}}),_c('img',{staticClass:"RImg",attrs:{"src":require("../../assets/入驻福利3.jpg")}})])
}]

export { render, staticRenderFns }